<template>
  <RevCard class="p-24">
    <RevContentBlock
      :button-label="i18n(translations.addNewButtonLabel)"
      :image-props="{
        alt: '',
        height: 257,
        src: '/img/empty.svg',
        width: 465,
      }"
      :title="i18n(translations.title)"
      :to="{ name: ROUTE_NAMES.LISTINGS.PRODUCT.CREATE }"
    >
      <p class="body-1">
        {{ i18n(translations.subtitle) }}
      </p>
    </RevContentBlock>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './NoResults.translations'

const i18n = useI18n()
</script>
